const url = import.meta.env.VITE_APP_API_NEWS

export default {
    actions: {
        async fetchFaqList({commit, getters}, categorySlug) {
            try {
                commit('SET_FAQ_LIST_STATUS', true)
                return  await fetch(`${url}/faq-list/${categorySlug}`, {
                        headers: {'Accept-Language': getters.getAppLanguage}
                    }).then(response => response.json())
                    .then(result => {
                        commit('SET_FAQ_LIST', result.code === 200 && result.data.items !== undefined? result.data.items : [])
                        commit('SET_FAQ_LIST_STATUS', false)
                    })
            } catch (e) {
                return []
            }
        },
        async fetchFaqCategoryList({commit, getters}) {
            try {
            commit('SET_CATEGORY_LIST_STATUS', true)
            return await fetch(`${url}/faq-categories`, {
                    headers: {'Accept-Language': getters.getAppLanguage}
                }).then(response => response.json())
                .then(result => {
                    commit('SET_CATEGORY_LIST', result.code === 200 && result.data.items !== undefined? result.data.items : [])
                    commit('SET_CATEGORY_LIST_STATUS', false)
                })
            } catch (e) {
                return []
            }
        },
        async fetchFaqVideoList({commit, getters}) {
            try {
            commit('SET_VIDEO_LIST_STATUS', true)
            return await fetch(`${url}/video-list`, {
                    headers: {'Accept-Language': getters.getAppLanguage}
                }).then(response => response.json())
                .then(result => {
                    commit('SET_VIDEO_LIST', result.code === 200 && result.data.items !== undefined? result.data.items : [])
                    commit('SET_VIDEO_LIST_STATUS', false)
                })
            } catch (e) {
                return []
            }
        }
    },
    mutations: {
        SET_FAQ_LIST(state, data) {
            state.faqList = data
        },
        SET_FAQ_LIST_STATUS(state, status) {
            state.faqListStatus = status
        },
        SET_CATEGORY_LIST(state, data) {
            state.faqCategoryList = data
        },
        SET_CATEGORY_LIST_STATUS(state, status) {
            state.faqCategoryListStatus = status
        },
        SET_VIDEO_LIST(state, data) {
            let i = 0
            state.faqVideoList = data.map((item) => {
                return {...item,
                    preview: `https://i.ytimg.com/vi_webp/${item.youtube_id}/maxresdefault.webp`,
                    link: ++i
                }
            })
        },
        SET_VIDEO_LIST_STATUS(state, status) {
            state.faqVideoListStatus = status
        }
    },

    state: {
        faqList: [],
        faqCategoryList: [],
        faqVideoList: [],
        faqListStatus: null,
        faqCategoryListStatus: null,
        faqVideoListStatus: null
    },
    getters: {
        getFaqListStatus:(state) => state.faqListStatus,
        getFaqCategoryListStatus:(state) => state.faqCategoryListStatus,
        getFaqList:(state) => state.faqList,
        getFaqCategoryList:(state) => state.faqCategoryList,
        getFaqVideoList:(state) => state.faqVideoList,
        getFaqVideoListStatus:(state) => state.faqVideoListStatus,
    }
}